import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import client from 'config/apolloConfig';
import App from './App';
import 'config/i18nConfig';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
);
